import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import {
  Header,
  CenteredModal,
  InputCol,
  SelectCol,
  Buttons,
  SearchDropdown,
} from "components/common/modals";
import { countries } from "utils/constants";
import axios from "axiosConfig";
import ConfirmModal from "components/common/modals/ConfirmModal";
// import {SelectBroker} from "utils/constants";
// Mock data for select inputs
const mockSelectBroker = [
  "Interactive Brokers",
  "Zerodha",
  "Other Brokers",
  "Email Notifications",
];

function SellModal({
  show,
  setShow,
  isShowEditModal,
  setSellData,
  sellData,

  ...props
}) {
  const {
    id,
    ticker,
    take_profit_percent,
    stop_loss_percent,
    partial_position,
    pe_ratio_increase,
    eps_drop,
    currency,
    max_quantity,
    on_off,
    selectBroker,
  } = sellData;

  const [inputs, setInputs] = useState({
    country: "",
    ticker: ticker || "",
    take_profit_percentage: take_profit_percent || "",
    stop_loss_percentage: stop_loss_percent || "",
    partial_position: partial_position || "",
    pe_ratio_increase: pe_ratio_increase ?? 0,
    eps_drop: eps_drop || 0,
    currency: currency || "",
    max_quantity: max_quantity || "",
    on_off: on_off || true,
    selectBroker: selectBroker || "",
  });

  useEffect(() => {
    if (!show) {
      // Reset inputs only if it's not in edit mode
      if (!isShowEditModal) {
        setInputs({
          country: "",
          ticker: "",
          take_profit_percentage: "",
          stop_loss_percentage: "",
          pe_ratio_increase: "",
          eps_drop: "",
          currency: "",
          partial_position: "",
          max_quantity: "",
          on_off: true,
          selectBroker: "",
        });
      }
    }
  }, [show, isShowEditModal]);

  const [errors, setErrors] = useState({
    ticker: "",
    take_profit_percentage: "",
    stop_loss_percentage: "",
    partial_position: "",
    max_quantity: "",
  });
  const [isConfirmModal, setIsConfirmModal] = useState(false);

  // Data to be passed to the request payload
  const [postData, setPostData] = useState([]);

  // Handle input change
  const onSubmit = async (event) => {
    event.preventDefault();

    // Validate all inputs
    let newPostData;
    let isError = false;
    for (const [key, value] of Object.entries(inputs)) {
      const errorMsg = validate(key, value);
      setErrors((prev) => ({ ...prev, [key]: errorMsg }));

      if (errorMsg?.length > 0) isError = true;
      // if (value.length !== 0 ) newPostData = { ...newPostData, [key]: value };
    }

    // Check for errors

    if (isError) return;
    try {
      if (isShowEditModal) {
        setPostData({
          ...inputs,
          on_off,
        });
        setIsConfirmModal(true);
      } else {
        newPostData = { ...inputs };
        const { data } = await axios.post("api/sell-setting/", {
          ...newPostData,
        });

        setSellData((prev) => [...prev, data]);
        setShow(false);
      }
    } catch (error) {
      console.log("Sell Settings error: ", error);
    }
  };
  // Form submit

  // Confirm update data
  const handleConfirmUpdate = async () => {
    try {
      const { data } = await axios.patch(`api/sell-setting/${id}/`, {
        ...postData,
      });
      setSellData((prev) => {
        const newDca = [...prev];
        const index = newDca.indexOf(sellData);

        newDca.splice(index, 1, data);
        return newDca;
      });
      setShow(false);
      setIsConfirmModal(false);
    } catch (error) {
      console.log("Sell Settings Error: ", error);
    }
  };

  // Handle input change

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    let newValue = value;
    if (type === "number") newValue = parseFloat(value);

    // Use a callback to update each input change immediately
    setInputs((curInputs) => ({ ...curInputs, [name]: newValue }));
    validateInput(e);
  };

  // Validate single input

  const validateInput = (e) => {
    let { name, value } = e.target;
    const errorMsg = validate(name, value);
    setErrors((prev) => ({ ...prev, [name]: errorMsg }));
  };

  const validate = (name, value) => {
    let errorMsg = "";

    if (!isShowEditModal) {
      switch (name) {
        case "ticker":
          errorMsg = value ? "" : "Please select a stock.";
          break;
        case "take_profit_percentage":
          errorMsg = value ? "" : "Please enter a value.";
          break;
        case "stop_loss_percentage":
          errorMsg = value ? "" : "Please enter a value.";
          break;
        case "partial_position":
          errorMsg = value ? "" : "Please enter a value.";
          break;
        case "max_quantity":
          errorMsg = value ? "" : "Please enter a value.";
          break;
        // Add additional cases as necessary for other fields
        default:
          break;
      }
    }

    return errorMsg;
  };
  const content = (
    <Container>
      <Row>
        {/* Header */}
        {/* Different setup for Add (Has Header) and Edit (Has no header) broker */}
        {!isShowEditModal && (
          <Header
            title={"Smart Take Profit"}
            text={
              <>
                {
                  "Automatically take profit on all shares or partial position in a stock based on multiple factors."
                }
                <br />
                {
                  "Set a stop-loss for partial quantity or all your shares in a particular company."
                }
              </>
            }
          />
        )}

        {/* Main Form Inputs */}

        <Col sm={12} lg={8} className="mt-4 mt-lg-5 mx-auto">
          <Form noValidate onSubmit={onSubmit}>
            <Row>
              <Col sm={12} className="mb-4 text-center text-lg-start">
                {/* Different setup for Add and Edit broker */}
                <h3>
                  {isShowEditModal
                    ? "Edit your SMART Take Profit instruction"
                    : "Add your SMART Take Profit"}
                </h3>
              </Col>
              {/* Main inputs */}

              <SelectCol
                label="Country"
                name={"country"}
                value={inputs.country}
                handleChange={handleChange}
                options={countries}
              />
              <SearchDropdown
                country={inputs.country}
                label="Stock"
                name={"ticker"}
                placeholder={"Select Stock"}
                value={inputs.ticker}
                handleChange={handleChange}
                errorMsg={errors.ticker}
                validateInput={validateInput}
                isValidate={true}
              />
              {/* Additional Inputs */}
              <Col sm={12} className="mt-4 mb-4 d-flex justify-content-center">
                <Container>
                  <Row
                    style={{
                      padding: "20px",
                      border: "1px solid #4C4B56",
                      borderRadius: "8px",
                    }}
                  >
                    <Col sm={12} className="px-0">
                      {/*<h5></h5>*/}
                    </Col>
                    <InputCol
                      label="Take Profit Percentage"
                      name={"take_profit_percentage"}
                      value={inputs.take_profit_percentage}
                      errorMsg={errors.take_profit_percentage}
                      validateInput={validateInput}
                      isValidate={true}
                      handleChange={handleChange}
                      colClass="mb-3 px-0 pe-lg-2"
                      placeholder="0"
                      hint="If the stock rises by this percentage of your purchase price, we will sell the stock"
                    />
                    <InputCol
                      label="Stop Loss"
                      name={"stop_loss_percentage"}
                      value={inputs.stop_loss_percentage}
                      errorMsg={errors.stop_loss_percentage}
                      validateInput={validateInput}
                      isValidate={true}
                      handleChange={handleChange}
                      colClass="mb-3 px-0 ps-lg-2"
                      placeholder="0"
                      hint="Set a stop-loss for your bought quantity"
                    />
                    <InputCol
                      label="Max Quantity to Sell"
                      name={"max_quantity"}
                      type="text"
                      value={inputs.max_quantity}
                      errorMsg={errors.max_quantity}
                      validateInput={validateInput}
                      isValidate={true}
                      handleChange={handleChange}
                      colClass="mb-3 px-0 pe-lg-2"
                      placeholder="1"
                      hint="Maximum quantity you would like to sell if condition is met"
                    />
                    <InputCol
                      label="Partial Position"
                      name={"partial_position"}
                      value={inputs.partial_position}
                      errorMsg={errors.partial_position}
                      validateInput={validateInput}
                      isValidate={true}
                      handleChange={handleChange}
                      colClass="mb-3 px-0 pe-lg-2"
                      placeholder="0"
                      hint="If you want to sell 50% of your position or any other percent."
                    />
                  </Row>
                </Container>
              </Col>

              {/* Footer Input */}
              <Col className="mb-3 mt-2" lg={12}>
                <SelectCol
                  label="Select Broker"
                  name={"selectBroker"}
                  value={inputs.selectBroker}
                  handleChange={handleChange}
                  colClass="px-0 mb-4 pe-lg-2"
                  options={mockSelectBroker}
                />
              </Col>
              {/* Buttons */}

              <Buttons
                setShow={setShow}
                isShowEditModal={isShowEditModal}
                addBtnText={"TAKE PROFIT"}
              />
            </Row>
          </Form>
        </Col>
      </Row>
      {/* Update confirmation modal */}
      <ConfirmModal
        show={isConfirmModal}
        handleClick={handleConfirmUpdate}
        setShow={setIsConfirmModal}
        header="Are you sure you want to Edit your Sell instruction?"
      />
    </Container>
  );

  return (
    <CenteredModal
      bodyContent={content}
      show={show}
      setShow={setShow}
      //  Different setup for Add and Edit broker
      size={isShowEditModal ? "lg" : "xl"}
    />
  );
}

export default SellModal;
